import React from 'react';
import { Brain, Loader2 } from 'lucide-react';

export const LoadingOverlay: React.FC = () => {
  return (
    <div className="fixed inset-0 bg-black/20 backdrop-blur-sm z-50 flex items-center justify-center">
      <div className="glass-card rounded-3xl p-12 max-w-md mx-4 text-center animate-slide-up">
        <div className="relative mb-6">
          <div className="absolute inset-0 bg-gradient-to-r from-primary-500 to-secondary-500 rounded-2xl blur-xl opacity-30 animate-pulse-glow"></div>
          <div className="relative bg-gradient-to-r from-primary-500 to-secondary-500 p-4 rounded-2xl inline-block">
            <Brain className="w-12 h-12 text-white animate-pulse" />
          </div>
        </div>
        
        <h3 className="text-2xl font-semibold text-gray-800 dark:text-gray-100 mb-2">
          Analizowanie transkryptu
        </h3>
        <p className="text-gray-600 dark:text-gray-300 mb-6">
          Nasza sztuczna inteligencja przetwarza twoją rozmowę sprzedażową...
        </p>
        
        <div className="flex items-center justify-center space-x-2">
          <Loader2 className="w-5 h-5 animate-spin text-primary-600 dark:text-primary-400" />
          <span className="text-primary-600 dark:text-primary-400 font-medium">
            Przetwarzanie
          </span>
        </div>
        
        <div className="mt-6 flex justify-center">
          <div className="flex space-x-1">
            <div className="w-2 h-2 bg-primary-500 rounded-full animate-bounce" style={{ animationDelay: '0ms' }}></div>
            <div className="w-2 h-2 bg-secondary-500 rounded-full animate-bounce" style={{ animationDelay: '150ms' }}></div>
            <div className="w-2 h-2 bg-accent-500 rounded-full animate-bounce" style={{ animationDelay: '300ms' }}></div>
          </div>
        </div>
      </div>
    </div>
  );
};